var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuppliers4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.446 2.69802C33.7074 2.26814 32.7906 2.26814 32.052 2.69802L3.55202 19.323C2.8229 19.7481 2.37402 20.5295 2.37402 21.375C2.37402 22.2205 2.8229 23.0019 3.55202 23.427L32.052 40.052C32.7906 40.4819 33.7074 40.4819 34.446 40.052L62.946 23.427C63.6751 23.0019 64.124 22.2205 64.124 21.375C64.124 20.5295 63.6751 19.7481 62.946 19.323L34.446 2.69802ZM33.249 7.50027L57.0346 21.375L33.249 35.2498L9.4634 21.375L33.249 7.50027Z",
    fill: "#58A291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.875 38V71.25C30.875 72.561 31.939 73.625 33.25 73.625C34.561 73.625 35.625 72.561 35.625 71.25V38C35.625 36.689 34.561 35.625 33.25 35.625C31.939 35.625 30.875 36.689 30.875 38Z",
    fill: "#58A291"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 21.375V54.625C2.375 55.936 3.439 57 4.75 57C6.061 57 7.125 55.936 7.125 54.625V21.375C7.125 20.064 6.061 19 4.75 19C3.439 19 2.375 20.064 2.375 21.375Z",
    fill: "#58A291"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.375 21.375V40.375C59.375 41.686 60.439 42.75 61.75 42.75C63.061 42.75 64.125 41.686 64.125 40.375V21.375C64.125 20.064 63.061 19 61.75 19C60.439 19 59.375 20.064 59.375 21.375Z",
    fill: "#58A291"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55256 56.677L32.0526 73.302C33.1854 73.9623 34.6413 73.5799 35.3016 72.447C35.9618 71.3142 35.5794 69.8583 34.4466 69.198L5.94656 52.573C4.81368 51.9128 3.35781 52.2952 2.69756 53.428C2.03731 54.5609 2.41968 56.0168 3.55256 56.677Z",
    fill: "#58A291"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1776 65.0418L32.0526 69.198C30.9197 69.8583 30.5373 71.3142 31.1976 72.447C31.8578 73.5799 33.3137 73.9623 34.4466 73.302L41.5716 69.1458C42.7044 68.4855 43.0868 67.0297 42.4266 65.8968C41.7663 64.7639 40.3104 64.3815 39.1776 65.0418Z",
    fill: "#58A291"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6711 31.8892L47.5134 14.2975C48.6082 13.5779 48.9146 12.1054 48.1974 11.0082C47.4777 9.91329 46.0052 9.60692 44.908 10.3242L18.0681 27.9182C16.9709 28.6354 16.6645 30.1079 17.3817 31.2052C18.1014 32.3024 19.5739 32.6088 20.6711 31.8892Z",
    fill: "#58A291"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1332 62.2416L56.5082 64.6166C56.9855 65.094 57.6434 65.3457 58.3179 65.3077C58.9924 65.2721 59.6194 64.9491 60.0422 64.4219L64.7922 58.4844C65.6115 57.4607 65.4453 55.9645 64.4217 55.1451C63.398 54.3257 61.9018 54.492 61.0824 55.5156L57.9902 59.3821L57.4914 58.8834C56.5652 57.9571 55.0594 57.9571 54.1332 58.8834C53.2069 59.8096 53.2069 61.3154 54.1332 62.2416Z",
    fill: "#58A291"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.375 45.125C51.5114 45.125 45.125 51.5114 45.125 59.375C45.125 67.2386 51.5114 73.625 59.375 73.625C67.2386 73.625 73.625 67.2386 73.625 59.375C73.625 51.5114 67.2386 45.125 59.375 45.125ZM59.375 49.875C64.619 49.875 68.875 54.131 68.875 59.375C68.875 64.619 64.619 68.875 59.375 68.875C54.131 68.875 49.875 64.619 49.875 59.375C49.875 54.131 54.131 49.875 59.375 49.875Z",
    fill: "#58A291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuppliers4);
export default __webpack_public_path__ + "static/media/icon-suppliers-4.bc0832aa34d00f026442c6ba020f645f.svg";
export { ForwardRef as ReactComponent };